// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"43563049","68":"ca9f0fe7","311":"cf63c1bf","322":"41ccbc53","410":"323ce932","441":"956ec030","446":"4989ddd6","595":"48201bf1","654":"2f363f73","799":"03a8c019","812":"b6be1ef4","868":"0baad276","902":"75737a26","910":"b23bbb23"}[chunkId] + ".chunk.js";
};